var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "index-wrap" }, [
    _c("div", { staticClass: "tabWrap" }, [
      _c("div", { staticClass: "scrollCon" }, [
        _c(
          "div",
          {
            attrs: {
              "scroll-into-view": "NAV" + _vm.status,
              "scroll-with-animation": "true"
            }
          },
          [
            _c(
              "div",
              { staticClass: "scroll-view-x" },
              _vm._l(_vm.navList, function(item, index) {
                return _c(
                  "div",
                  { key: index, staticStyle: { "padding-left": "5px" } },
                  [
                    _c(
                      "div",
                      {
                        class: "scrollpadding" + index,
                        attrs: { id: "NAV" + index, "data-index": index },
                        on: {
                          click: function($event) {
                            return _vm.getStatus(index)
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            class: index === _vm.status ? "selected" : "default"
                          },
                          [
                            _c("label", { staticClass: "itemtitle" }, [
                              _vm._v(_vm._s(item.title))
                            ]),
                            _vm._v(" "),
                            _c("img", {
                              class:
                                index === _vm.status
                                  ? "selectImg biger"
                                  : "selectImg small",
                              attrs: { src: item.imgSrc }
                            }),
                            _vm._v(" "),
                            _c("label", { staticClass: "itemsummary" }, [
                              _vm._v(_vm._s(item.summary))
                            ])
                          ]
                        )
                      ]
                    )
                  ]
                )
              }),
              0
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "switchBoard" }, [
        _c("div", { class: _vm.selected ? "show" : "hidden" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticStyle: { height: "0.5px" } })
        ]),
        _vm._v(" "),
        _c("div", { class: _vm.selected1 ? "show" : "hidden" }, [
          _c("div", { staticClass: "icCardBoard" }, [
            _c("div", { staticClass: "icCardTab" }, [
              _c(
                "div",
                {
                  class: _vm.temaiSelect ? "temaiselected" : "temaidefault",
                  on: { click: _vm.temaiSelectClick }
                },
                [_c("span", { staticClass: "title" }, [_vm._v("公交服务点")])]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "line" }),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: _vm.temaiSelect1 ? "temaiselected" : "temaidefault",
                  on: { click: _vm.temaiSelect1Click }
                },
                [_c("span", { staticClass: "title" }, [_vm._v("邮政代办点")])]
              )
            ]),
            _vm._v(" "),
            _c("div", { class: _vm.temaiSelect ? "show" : "hidden" }, [
              _c(
                "div",
                { staticClass: "busServerBorad" },
                [
                  _vm._l(_vm.busServerLists, function(item) {
                    return _c(
                      "div",
                      { key: item.name, staticClass: "busServerItem" },
                      [
                        _c("label", { staticClass: "name" }, [
                          _vm._v(_vm._s(item.name))
                        ]),
                        _vm._v(" "),
                        _c("label", { staticClass: "address" }, [
                          _vm._v(_vm._s(item.address))
                        ])
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "busServerItem",
                      attrs: {
                        "data-clipboard-text": "http://www.fbchong.com"
                      },
                      on: { click: _vm.copyLink }
                    },
                    [
                      _c("label", { staticClass: "name" }, [
                        _vm._v("网上充值")
                      ]),
                      _vm._v(" "),
                      _vm._m(1)
                    ]
                  )
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("div", { class: _vm.temaiSelect1 ? "show" : "hidden" }, [
              _c(
                "div",
                { staticClass: "busServerBorad" },
                _vm._l(_vm.chinaPostLists, function(item) {
                  return _c(
                    "div",
                    { key: item.name, staticClass: "busServerItem" },
                    [
                      _c("label", { staticClass: "name" }, [
                        _vm._v(_vm._s(item.name))
                      ])
                    ]
                  )
                }),
                0
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mb" })
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.toastShow,
            expression: "toastShow"
          }
        ],
        staticClass: "toast"
      },
      [_vm._v("\n    " + _vm._s(_vm.toastText) + "\n  ")]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "goukaboard" }, [
      _c("div", { staticClass: "goukason goukason3" }, [
        _c("label", { staticClass: "title" }, [_vm._v("公交卡")]),
        _vm._v(" "),
        _c("label", { staticClass: "description" }, [
          _vm._v("服务窗口：公交服务点，邮政代办点"),
          _c("br"),
          _vm._v("\n              网上充值：方便充APP")
        ]),
        _vm._v(" "),
        _c("img", {
          attrs: { src: require("../../static/images/busSupport/wl_yjgk.png") }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "goukason goukason5" }, [
        _c("label", { staticClass: "title" }, [_vm._v("银联卡")]),
        _vm._v(" "),
        _c("label", { staticClass: "description" }, [
          _vm._v("62开头带芯片，有银联标识，有闪付标识 "),
          _c("br"),
          _vm._v("\n              需开通小额免密支付功能")
        ]),
        _vm._v(" "),
        _c("img", {
          attrs: { src: require("../../static/images/busSupport/wl_yztcc.png") }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "goukason goukasonWechat" }, [
        _c("label", { staticClass: "title" }, [_vm._v("微信乘车码")]),
        _vm._v(" "),
        _c("label", { staticClass: "description" }, [
          _vm._v('微信小程序搜"乘车码"，选择南充市')
        ]),
        _vm._v(" "),
        _c("img", {
          attrs: { src: require("../../static/images/busSupport/wl_yjgk.png") }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "goukason goukason1" }, [
        _c("label", { staticClass: "title" }, [_vm._v("支付宝乘车码")]),
        _vm._v(" "),
        _c("label", { staticClass: "description" }, [
          _vm._v("支付宝APP首页搜索：南充市乘车码")
        ]),
        _vm._v(" "),
        _c("img", {
          attrs: { src: require("../../static/images/busSupport/wl_hmzx.png") }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "goukason goukason2" }, [
        _c("label", { staticClass: "title" }, [_vm._v("云闪付乘车码")]),
        _vm._v(" "),
        _c("label", { staticClass: "description" }, [
          _vm._v("云闪付APP，绑定任意银联卡，选择南充市")
        ]),
        _vm._v(" "),
        _c("img", {
          attrs: { src: require("../../static/images/busSupport/wl_xxsz.png") }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "goukason goukason4" }, [
        _c("label", { staticClass: "title" }, [_vm._v("天府银行乘车码")]),
        _vm._v(" "),
        _c("label", { staticClass: "description" }, [
          _vm._v("天府手机银行APP，绑定天府银行卡")
        ]),
        _vm._v(" "),
        _c("img", {
          attrs: { src: require("../../static/images/busSupport/wl_yztc.png") }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "address" }, [
      _vm._v("点击此处复制方便充APP地址："),
      _c("br"),
      _vm._v("\n                  http://www.fbchong.com")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c3b0686", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c3b0686","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/BusSupport.vue
// module id = null
// module chunks = 